export class ReverseYAxisEmitter {
    constructor(element, button, onActivate) {
        this.el = element;
        this.emitReverseY = this.emitReverseY.bind(this);
        this.onActivate = onActivate;
        this.button = button;
        this.removeListeners = this.removeListeners.bind(this);

        element.addEventListener(button, this.emitReverseY);
    }

    emitReverseY(event) {
        event.detail.axis[1] *= -1;
        this.onActivate(event);
    }

    removeListeners() {
        this.el.removeEventListener(this.button, this.emitReverseY);
    }
}
